import {
  Box,
  Typography,
  Paper,
  IconButton,
  Chip,
  useTheme,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";

import { hexToRgba } from "@aclymatepackages/converters";

const PortfolioCard = ({
  hover = true,
  isSelected,
  portfolio,
  setShowPortfolioDetails,
}) => {
  const theme = useTheme();

  const { name, primary_image_url, displayPrice } = portfolio || {};

  return (
    <Paper
      elevation={hover ? 4 : 1}
      style={{
        width: "100%",
        paddingTop: 200,
        overflow: "hidden",
        position: "relative",
        border: isSelected
          ? `2px solid ${theme.palette.secondary.main}`
          : "none",
        backgroundImage: `url(${
          primary_image_url || "/images/project-categories/conservation1.jpg"
        })`,
        backgroundSize: "cover",
      }}
    >
      <Box
        position="absolute"
        style={{
          left: 0,
          right: 0,
          bottom: 0,
          background: `linear-gradient(135deg, ${hexToRgba(
            theme.palette.primary.main,
            0.95
          )} 0%, ${hexToRgba(theme.palette.secondary.main, 0.5)} 100%)`,
          color: "white",
        }}
        p={1}
      >
        <Typography variant="h4" color="inherit" noWrap>
          {name}
        </Typography>
      </Box>
      <IconButton
        style={{ position: "absolute", top: 0, right: 0 }}
        onClick={(e) => {
          e.stopPropagation();
          return setShowPortfolioDetails(portfolio);
        }}
      >
        {displayPrice ? (
          <Chip
            color="primary"
            icon={<AttachMoneyIcon />}
            label={displayPrice}
          />
        ) : (
          <FontAwesomeIcon
            icon={faCircleInfo}
            style={{ color: "white" }}
            size="xl"
          />
        )}
      </IconButton>
    </Paper>
  );
};
export default PortfolioCard;
